/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerFindAllQueryResponse, RegionsControllerFindAllQueryParams, RegionsControllerFindAll401, RegionsControllerFindAll403 } from "../../models/regionsController/RegionsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { regionsControllerFindAll } from "../../clients/regionsService/regionsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const regionsControllerFindAllQueryKey = (params: RegionsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/regions'
}, ...(params ? [params] : [])] as const;
export type RegionsControllerFindAllQueryKey = ReturnType<typeof regionsControllerFindAllQueryKey>;
export function regionsControllerFindAllQueryOptions(params?: RegionsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = regionsControllerFindAllQueryKey(params);
  return queryOptions<RegionsControllerFindAllQueryResponse, ResponseErrorConfig<RegionsControllerFindAll401 | RegionsControllerFindAll403>, RegionsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return regionsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all regions
 * {@link /api/v1/regions}
 */
export function useRegionsControllerFindAll<TData = RegionsControllerFindAllQueryResponse, TQueryData = RegionsControllerFindAllQueryResponse, TQueryKey extends QueryKey = RegionsControllerFindAllQueryKey>(params?: RegionsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<RegionsControllerFindAllQueryResponse, ResponseErrorConfig<RegionsControllerFindAll401 | RegionsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? regionsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...regionsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RegionsControllerFindAll401 | RegionsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}